<template>
	<span>
		<span :class="['label-text', {'add-colon': level === 0 && hasSelectedChildsToLastLevel}]">
			<span v-if="item.freeText">{{ item.freeText }}</span>
			<Label v-else :characteristic="item.item" :label-type="labelType"/>
			<span v-if="!isLastLevel && !hasSelectedChildsToLastLevel && noChildrenAppendix">
				({{ computedNoChildrenAppendix }})
			</span>
			<span v-if="labelAppendix" class="label-appendix">{{ labelAppendix }}</span>
		</span>
		<span v-if="hasIcon" class="label-icon">
			<img
				:src="iconPath + '/' + item.item.naturalId + '.svg'"
				:alt="item.item.label"
			/>
		</span>
		</span>
</template>
<script>
import Label from "@/vue/characteristic/Label.vue";

export default {
	components: {
		Label
	},

	props: {
		item: {
			type: Object,
			required: true,
		},
		noChildrenAppendix: {
			type: [String, Object],
			required: false,
		},
		labelAppendix: {
			type: String,
			required: false,
		},
		labelType: {
			type: String,
			required: false,
		},
		level: {
			type: Number,
			required: true
		},
		iconPath: {
			type: String,
			required: false,
		},
		hasIcon: {
			type: Boolean,
			required: false,
		},
		hasSelectedChildsToLastLevel: {
			type: Boolean,
			required: true,
		},
		isLastLevel: {
			type: Boolean,
			required: true,
		},
	},

	computed: {
		computedNoChildrenAppendix ()
		{
			if (typeof this.noChildrenAppendix === 'string')
			{
				return this.noChildrenAppendix;
			}

			return this.noChildrenAppendix[this.level];
		},
	}
}
</script>
